import React from "react";
import { FormattedMessage } from "react-intl";
import { ConfirmDialogControl } from "../../hooks/useConfirmDialog";
import { ConfirmDialog } from "../ConfirmDialog";
import { extraImpactDialogMessages as messages } from "./ExtraImpactDialog.messages";
import { ExtraImpactDialogView } from "./extraImpactDialog.viewModel";
import { ImpactSections } from "./ImpactSections";

/** One combined confirmation of an extra change, with a section per impact. */
export function ExtraImpactDialog({
  show,
  content,
  onConfirm,
  onCancel,
}: ConfirmDialogControl<ExtraImpactDialogView>) {
  return (
    <ConfirmDialog
      show={show}
      title={content?.title}
      confirmLabel={<FormattedMessage {...messages.continue} />}
      cancelLabel={<FormattedMessage {...messages.cancel} />}
      onConfirm={onConfirm}
      onCancel={onCancel}>
      {content?.preface && <p>{content.preface}</p>}
      <ImpactSections sections={content?.sections ?? []} />
    </ConfirmDialog>
  );
}
